<template>
    <div :class="classObject">
        <div :class=classLeft>
            <div class="comTitle left-title">
                <el-date-picker v-model="timeValue" value-format="timestamp" type="date" placeholder="选择日期"
                    :picker-options="pickerOptions" :clearable="false"/>
                <el-button type="primary" size="medium" @click="changeDay('prev')">上一日</el-button>
                <el-button type="primary" size="medium" @click="changeDay('next')" :disabled="disabledNext()">下一日</el-button>
                <el-button type="primary" size="medium" @click="queryCharts">查询</el-button>
            </div>
            <div class="comContentBox left-content">
                <DeviceEcharts :assetId="assetId" :key="deviceId" :deviceId="deviceId" :deviceName="deviceName"
                    :deviceTypes="deviceTypes" :paramsSubType="paramsSubType" :timeValue="timeValue"  :energyType="energyType"/>
            </div>
        </div>
        <div class="ashComWrap right" v-if="deviceParamsList.length">
            <div class="comTitle">
                <h4>{{ deviceParamsTitle || '运行情况' }}</h4>
            </div>
            <div class="right-content" v-for="(v, index) in deviceParamsList" :key="index">
                <DeviceParamsItem :dataObj="v" />
            </div>
        </div>
    </div>
</template>
<script>
const classNames = require('classnames')
import DeviceEcharts from './DeviceEcharts.vue';
import DeviceParamsItem from './DeviceParamsItem.vue';
import api from "@/api";
import {
    getProjectVal,
} from "@/assets/js/utils";
export default {
    components: { DeviceEcharts, DeviceParamsItem },
    name: "DeviceList",
    props: {
        deviceId: {
            type: String,
            default: "",
        },
        deviceName: {
            type: String,
            default: "全部",
        },
        className: {
            type: String,
            default: ""
        },
        assetId: {
            type: String,
            default: "",
        },
        deviceTypes: {
            type: String,
            default: "中央空调主机",
        },
        //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
        energyType: {
            type: String,
            default: "cool",
        },
    },
    data() {
        return {
            timeValue: new Date().getTime(),
            deviceParamsTitle: '运行情况',
            deviceParamsEvn: [
                //     {
                //     title: '环境参数', content: [{
                //         name: '环境温度',
                //         value: 3,
                //         unit: '℃'
                //     }, {
                //         name: '湿球温度',
                //         value: 3,
                //         unit: '℃'
                //     }, {
                //         name: '相对湿度',
                //         value: 3,
                //         unit: '℃'
                //     }, {
                //         name: '风速',
                //         value: 3,
                //         unit: 'm/s'
                //     }]
                // }
            ],
            deviceParamsOther: [
                //     {
                //     title: '运行情况', content: [{
                //         name: '实际运行时长',
                //         value: "888天88小时88分",
                //     }], twoLine: true
                // }, 
                // {
                //     title: '额定参数', content: [{
                //         name: '额定功率',
                //         value: 3,
                //         unit: 'kw'
                //     }, {
                //         name: '额定制冷量',
                //         value: 3,
                //         unit: 'kw'
                //     }, {
                //         name: '额定COP',
                //         value: 3,
                //         unit: 'kw'
                //     }]
                // }
            ],
            //日期范围限制
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        }
    },
    computed: {
        classObject: function () {
            return classNames({
                'deviceList': true,
                [this.className]: !!this.className,
            })
        },
        classLeft: function () {
            return classNames({
                'left': true,
                'onlyLeft': this.deviceParamsList.length === 0,
            })
        },
        paramsSubType: function () {
            return this.deviceName === "全部" ? 'total' : 'single'
        },
        deviceParamsList: function () {
            return this.deviceParamsOther.concat(this.deviceParamsEvn)
        }
    },
    methods: {
        changeDay(type) {
            if (type === "prev") {
                this.timeValue -= 1000 * 60 * 60 * 24
            } else {
                this.timeValue += 1000 * 60 * 60 * 24
            }
        },
        disabledNext() {
            const newTime = this.timeValue + 1000 * 60 * 60 * 24
            return newTime > Date.now() ? true : false
        },
        //获取额定参数
        async getRatedParameters() {
            const params = {
                assetId: this.assetId,
                assetType: "中央空调系统",
                deviceId: this.deviceId,
                deviceType: this.deviceTypes === "主机能效" ? "中央空调主机" : this.deviceTypes,
            }
            if (this.deviceName === "全部") {
                delete params.deviceId
                if (params.deviceType === "分集水管") {
                    params.deviceType = "分集水器"
                }
            }
            let res = await api.ACRGetRatedParameters(params);
            if (res && res.data.code == 200) {
                this.deviceParamsOther = [{
                    title: '额定参数', content: res.data.data
                }]
            } else {
                console.log("获取额定参数失败");
            }
        },
        //环境监测
        async getEnvironmentalMonitoring() {
            let res = await api.ACRGetEnvironmentalMonitoring({
                projectId: getProjectVal('Id'),
                assetId: this.assetId,
                modular: "环境监测",
            });
            if (res && res.data.code == 200) {
                this.deviceParamsEvn = [{
                    title: '环境参数', content: res.data.data
                }]
            } else {
                console.log("获取中央空调概览失败");
            }
        },
        queryCharts() {
            this.$bus.$emit("getChartsByParameters");
        }
    },
    created() {
        // if (!['主机能效'].includes(this.deviceTypes)) {
        //     this.getRatedParameters()
        //     this.getEnvironmentalMonitoring()
        // }
        if (this.energyType==="cool") {
            this.getRatedParameters()
            this.getEnvironmentalMonitoring()
        } else {
            this.deviceParamsEvn=[]
            this.deviceParamsOther=[]
        }  
    },
}
</script>
<style  lang="scss" scoped>
.deviceList {
    height: 650px;
    @include setFlexBetween;

    .left {
        flex-grow: 1;
        width: 1338px;
        height: 100%;

        &-title {
            justify-content: flex-start;
            align-items: center;
            padding: 0 35px;

            &>button {
                margin-left: 10px;
            }
        }

        &-content {}
    }

    .onlyLeft {
        width: 100%;
    }

    .right {
        margin-left: 8px;
        width: 270px;

        flex-grow: 0;
        &-content {
            // height: 177px;
            border-radius: 8px;
            width: 236px;
            margin: 14px auto;
        }
    }
}
</style>